
export const addressHelper = {
  format,
}

function format(c: { street?: string | undefined, streetNum?: string| undefined, city?: string| undefined, zipCode?: string | undefined}, withZipCode: boolean = false): string {
  return `${c.street} ${c.streetNum}${(withZipCode) ? ', ' + c.zipCode : ''}, ${c.city}`; 
}

